module.exports = __webpack_public_path__ + "img/user-14.51a23c07.png";